/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'earnings_icon': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M16.65 4.95h-.45V4.5a1.35 1.35 0 00-1.35-1.35H1.35A1.35 1.35 0 000 4.5v7.2c0 .746.605 1.35 1.35 1.35h.45v.45c0 .746.605 1.35 1.35 1.35h13.5A1.35 1.35 0 0018 13.5V6.3a1.35 1.35 0 00-1.35-1.35zM.9 11.7V4.5a.45.45 0 01.45-.45h13.5a.45.45 0 01.45.45v7.2a.45.45 0 01-.45.45H1.35a.45.45 0 01-.45-.45zm16.2 1.8a.45.45 0 01-.45.45H3.15a.45.45 0 01-.45-.45v-.45h12.15a1.35 1.35 0 001.35-1.35V5.85h.45a.45.45 0 01.45.45v7.2z" _fill="#62E2AA"/><path pid="1" d="M8.1 10.35a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zm0-3.6a1.35 1.35 0 110 2.7 1.35 1.35 0 010-2.7zM12.15 5.851h1.8a.45.45 0 000-.9h-1.8a.45.45 0 000 .9zM4.05 11.25a.45.45 0 000-.9h-1.8a.45.45 0 000 .9h1.8z" _fill="#62E2AA"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/earnings_icon.js